import React from 'react'
import { UiGetCustomer, documentation as UiGetCustomerDoc } from "./uiGetCustomer";
import UiField from './uiField';
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { renderReport } from '../components/elementList';


let documentation = {
    title: 'New Field',
    subtitle: 'Adds a new field to Thingsboard Acuadori',
    brief: <p>Adds a new field to Thingsboard for each type of customer chosen on <i>Choose Customer</i> step.</p>,
    content: <p><span className="text-warning">WARNING: </span> Pre-condition: The customers should be already present in Thingsboard.
        In the <i>Add Field</i> step the field is created. The field name is automatically started with the chosen
        customer base name. Along with the field an entity view for each customer-type of the chosen customer is created.
        Setting the field perimeter coordinates the coordinates, and an auto-calculated center [latitude, longitude] point
        is added to thingsboard field. Field's related EntityViews inherit Coordinates, latitude and longitude parameters.
        <p><b>All entity-views are assigned and linked</b> through a relation to the corresponding <b>customer type.</b></p>
        <p>The field (asset) <b>is not assigned nor related</b> to the customer.</p></p>,


    steps: [
        { id: 0, ...UiGetCustomerDoc },
        {
            id: 1,
            title: 'Add Field',
            brief: 'Adds a field and a number of EntityViews.',
            content: <p>Creates a field as a Thingsboard Asset.</p>
            // Each Entity view is related to the customer-type. All EntityViews are assigned and linked through a relation
            // to the corresponding customer type. Due to the customer relation and the EntityView type, the field is automatically
            // (through a query declared in the dashboard) added to the dashboard.</p>

        },
    ]
};

class UiAddField extends React.Component {

    static defaultProps = {};
    constructor(props) {
        super(props);
        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,
            dashboardName: '',

            customer: { name: '', agronomist: null, operator: null },
            field: { data: null, report: null },

        };
    }

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };

    documentation = (title) => {
        if (!title) { return documentation; }

        let doc = documentation;
        documentation.title = title;
        return doc;
    }


    renderGetCustomerForm = () => {
        return (
            <UiGetCustomer
                error={this.handleSubmitError}
                services={{ customer: this.props.services.customer }}
                finished={(report) => {
                    this.setState({ customer: report });
                    this.stepManagerAdvance();
                }
                } />
        );
    };

    renderFieldForm = () => {
        return (
            <UiField
                services={{
                    asset: this.props.services.asset,
                    customer: this.props.services.customer
                }}
                customer={this.state.customer}
                finished={(fieldData, report) => {
                    this.setState({ field: { data: fieldData, report: report } });
                    this.stepManagerAdvance();
                }}
            />
        );
    };

    render() {
        let documentation = this.documentation(this.props.title);
        let { field } = this.state;

        return (
            <div className="container-fluid">
                {this.state.finished && <Redirect to={this.state.nextRoute} />}
                <StepManager ref={this.stepManagerRef}
                    startStepId={0} endStepId={1}
                    onFinished={() => {
                        //window.open( this.props.links.thingsboardRoutes.dashboards );
                        this.setState({ finished: true });
                        this.stepManagerAdvance();
                    }}
                    stepList={[
                        {
                            stepId: 0, stepName: documentation.steps[0].title, formValue: this.renderGetCustomerForm,
                            documentation: documentation.steps[0]
                        },
                        {
                            stepId: 1, stepName: documentation.steps[1].title, formValue: this.renderFieldForm, dataValue: () => renderReport(field.report),
                            documentation: documentation.steps[1]
                        },
                    ]}
                    documentation={documentation}
                />
            </div>
        );
    }
}


export default UiAddField;
export {UiAddField, documentation}
